import { z } from 'zod';

const NewCardPaymentMethodSchema = z.object({
    type: z.literal('Card'),
    flow: z.literal('new'),
    cardSession: z.string(),
    cardCvvSession: z.string(),
    cardHolderName: z.string(),
});

const ThreeDsAuthenticationResultSchema = z.object({
    eci: z.string().optional().nullable(),
    authenticationValue: z.string().optional().nullable(),
    transactionId: z.string().optional().nullable(),
    version: z.string().optional().nullable(),
});

const AuthenticationSchema = z.object({
    threeDS: ThreeDsAuthenticationResultSchema,
});

const SavedCardPaymentMethodSchema = z.object({
    type: z.literal('Card'),
    flow: z.literal('saved'),
    paymentMethodId: z.string().optional(),
    tokenHref: z.string(),
    savedCardCvcSession: z.string(),
});

const ApplePayPaymentMethodSchema = z.object({
    type: z.literal('ApplePay'),
    walletToken: z.string(),
    cardHolderName: z.string().optional(),
});

const GooglePayPaymentMethodSchema = z.object({
    type: z.literal('GooglePay'),
    walletToken: z.string(),
});

export const InputSchema = z.object({
    amount: z.number(),
    currencyCode: z.string(),
    paymentMethod: z.union([
        NewCardPaymentMethodSchema,
        SavedCardPaymentMethodSchema,
        ApplePayPaymentMethodSchema,
        GooglePayPaymentMethodSchema,
    ]),
    authentication: AuthenticationSchema.optional(),
    transactionId: z.number().optional(),
    description: z.string(),
});

export type CreatePaymentWorldpayType = z.infer<typeof InputSchema>;

export const SuccessResponseSchema = z.object({
    transactionId: z.number(),
    status: z.string(),
    transactionReference: z.string().optional().nullable(),
});

type TsuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export const ErrorResponseSchema = z.object({
    errors: z.array(
        z.object({
            code: z.string().optional().nullable(),
            message: z.string().optional().nullable(),
            details: z.array(z.string()).optional().nullable(),
        })
    ),
});

type TerrorResponseType = z.infer<typeof ErrorResponseSchema>;

export type TresponseType =
    | { responseStatus: 'success'; response: TsuccessResponseType }
    | { responseStatus: 'error'; data: TerrorResponseType };
